import './carouselIndustries.css';
import React, { useState } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import CarouselBackground from './carouselBackground/carouselBackground';
import Arrow from '../../../../assets/icons/arrows/arrow';
import Button from '../../../../components/button/button'
import SpaceBar from '../../../../components/spacerBars/spaceBar';
import CourouselIcons from './carouselIcons/courselIcons';
import ExpensibleStamp from '../../../../assets/icons/expensibleStamp/expensibleStamp';
import IconsBackground from '../../../../assets/icons/iconsBackground/iconsBackground';

export default function CarouselIndustries({isMobile}){

    const navigate = useNavigate();

    const getStarted = () => {
        navigate('/sign_up'); 
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
            });
    };

    const [carouselIndex, setCarouselIndex] = useState(0);
    const [imgPopIndex, setImgPopIndex] = useState(0);

    const carouselRight = () => {
        setCarouselIndex((carouselIndex + 1) % 9);
        setImgPopIndex((imgPopIndex + 1) % 2);
    };

    const carouselLeft = () => {
        setCarouselIndex((carouselIndex - 1 + 9) % 9);
        setImgPopIndex((imgPopIndex - 1 + 2) % 2);
    };

    const carouselTitle = [
        'Capture every cost, your way!',
        'Track how you run your warehouse!',
        'Tow your expenses wherever the job takes you!',
        'Take control of expenses on every haul!',
        'Grow your operation with better cost visibility!',
        'Build a more efficient manufacturing business!',
        'Keep your logging operation on track!',
        'Stay on budget from the first blueprint to the final build!',
        'Whatever your industry, we have your back!'
        ];

    const carouselContent = [
        'Expensable fits any business model. Browse the carousel to explore industry-specific examples, key benefits, and a short case highlight showing how teams use our tracking, reporting, and forecasting tools to save time and money.',

        'Manage warehouse expenses with a clearer view of inventory, labor, equipment, shipping, and supply costs. Expensable helps warehouse teams organize spending, reduce waste, and make faster operational decisions.',

        'Keep every towing expense under control, from fuel and repairs to insurance, tolls, and driver costs. Expensable helps towing companies track expenses by vehicle, route, customer, or job so they can improve profitability.',

        'Track fuel, maintenance, permits, tolls, payroll, and trip expenses across every route. Expensable helps trucking companies understand cost per mile, forecast upcoming expenses, and protect profits on every haul.',

        'Track the costs that keep your operation growing, including fuel, equipment, seed, fertilizer, labor, livestock, and repairs. Expensable helps agricultural teams compare spending across fields, crops, projects, and seasons.',

        'Gain control over materials, labor, equipment, production, maintenance, and shipping expenses. Expensable gives manufacturing teams the reports and forecasting tools they need to reduce waste and improve margins.',

        'Manage fuel, equipment, repairs, transportation, labor, and site expenses from one flexible platform. Expensable helps logging companies monitor costs across crews, equipment, jobs, and remote worksites.',

        'Keep construction costs organized across materials, subcontractors, equipment rentals, permits, labor, and fuel. Expensable connects every expense to the right project so teams can stay on budget and avoid costly overruns.',

        'No matter how your business operates, Expensable can adapt to your workflow. Customize categories, reports, and forecasting tools to track the expenses that matter most to your team and make better financial decisions.'
        ];

    return(
        <div className="carousel-industries">
            <div className="carousel-industries-contain">
                <CarouselBackground carouselIndexImg={carouselIndex} imgPopIndex={imgPopIndex}/>
                <div className="courousel-container">
                    <div className="carousel-industries-icons">
                        <IconsBackground/>
                        <ExpensibleStamp/>
                    </div>
                    <div className="coursel-content-grid">
                        <div className="courousel-content">
                            <h2>Expense management built for every industry</h2>
                            <SpaceBar width={'20rem'}/>
                            <h3>{carouselTitle[carouselIndex]}</h3>
                            <p>{carouselContent[carouselIndex]}</p>
                        </div>
                        <div className="carousel-control-center arrow-bubbles-mobile-selector">
                            <Arrow point={true} onClick={carouselLeft}/>
                            <Button buttonName="Get Started!" onClick={getStarted}/>
                            <Arrow point={false} onClick={carouselRight}/>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <CourouselIcons carouselIndexIcon={carouselIndex} isMobile={isMobile}/>
            </div>
        </div> 
    )
};